import header from '../views/common/header';
import gnb from '../views/common/gnb';

export default [
  {
    path: '/views/custom/spc/overview/system',
    meta: { stackType: 'ALL' },
    components: {
      default: () => import('@/views/custom/spc/overview/system'),
      header,
      gnb,
    },
  },
  {
    path: '/views/custom/spc/overview/system/:systemId',
    meta: { stackType: 'ALL' },
    components: {
      default: () => import('@/views/custom/spc/overview/system'),
      header,
      gnb,
    },
  },
  {
    path: '/views/custom/spc/statistics/top-list',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('@/views/custom/spc/statistics/top-list'),
      header,
      gnb,
    },
  },
  {
    path: '/views/custom/spc/statistics/top-list/:systemId',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('@/views/custom/spc/statistics/top-list'),
      header,
      gnb,
    },
  },
  // BEGIN::Added.by.HJSeo.2026.07.02. LEM 고객사 전용 정기점검 리포트
  {
    path: '/views/custom/lem/statistics/checklist',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('@/views/custom/lem/statistics/checklist'),
      header,
      gnb,
    },
  },
  {
    path: '/views/custom/lem/statistics/checklist/:systemId',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('@/views/custom/lem/statistics/checklist'),
      header,
      gnb,
    },
  },
  // FINISH::Added.by.HJSeo.2026.07.02.
];
